<template>
  <div class="px-3 pt-2 h-full overflow-auto pb-5">
    <VariableSelect v-model="aiPayload.variable" :filterDataType="['Text']" label="Assign to Variable" @update:modelValue="emitPayload" />
    <FormSelect
      :label="$t('evaluate.provider')"
      v-model="aiPayload.provider"
      :options="providers"
      :selectable="(option) => !option.disabled"
      :reduce="(option) => option.value"
      class="w-full mt-3"
      @update:modelValue="onProviderChange"
    />
    <FormSelect :label="$t('evaluate.model')" v-model="aiPayload.model" :options="models" :reduce="(option) => option.value" class="w-full mt-3" @update:modelValue="emitPayload" />
    <FormSelect
      :label="`${$t('evaluate.persona')} (Optional)`"
      v-model="aiPayload.persona"
      :options="personas"
      :reduce="(option) => option.value"
      class="w-full mt-3"
      show-add-button
      clearable
      @add="onAddPersonaClick"
      @update:modelValue="emitPayload"
    />
    <PhraseEditor v-model="aiPayload.context" multiline :items="variables" class="w-full mt-3" :label="$t('evaluate.context')" @update:modelValue="emitPayload" />
    <VariableSelect label="Select file variable for upload (Optional)" v-model="aiPayload.file" class="mt-3 w-full" :filter-data-type="['PDF', 'Image']" @update:modelValue="emitPayload" />
    <FormInput :label="$t('evaluate.max_tokens')" v-model="aiPayload.max_length" type="number" class="w-full mt-3" @update:modelValue="emitPayload" />

    <div class="flex flex-col pb-5">
      <FormLabel class="mt-3" :label="$t('evaluate.temperature')" />
      <div class="flex">
        <input type="range" v-model="aiPayload.temperature" min="0" max="1" step="0.1" class="max-w-200" @input="emitPayload" />
        <input type="number" v-model="aiPayload.temperature" min="0" max="1" step="0.1" class="w-12 ml-2 bg-white border-stroke border-solid border rounded-4 px-1" @input="emitPayload" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CreatePersonaModal from '@/components/project/CreatePersonaModal.vue';
import EvaluateItemsConfig from '@/components/flow/evaluate/EvaluateItemsConfig';
import debounce from '../../../helpers/debounce';

export default {
  name: 'TextGenerationConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      aiPayload: structuredClone(EvaluateItemsConfig['ai-text-generation'].payload),
    };
  },
  computed: {
    ...mapState(['availableAIProviders']),
    ...mapGetters(['getProjectAIProviderOptions', 'getProjectPersonas', 'getProjectVariables']),
    payload() {
      return {
        id: this.item.id,
        type: this.item.type,
        payload: this.aiPayload,
      };
    },
    providers() {
      return this.getProjectAIProviderOptions();
    },
    personas() {
      return Object.values(this.getProjectPersonas()).map((item) => ({ label: item.name, value: item.persona_id }));
    },
    models() {
      if (!this.aiPayload.provider) return [];
      return Object.values(this.availableAIProviders[this.aiPayload.provider].models).map((item) => ({
        label: `<b>${item.name}</b> - <i class="text-11">Cost: ${item.cost}</i>`,
        value: item.model,
      }));
    },
    projectId() {
      return this.$route.params.projectId;
    },
    variables() {
      return Object.keys(this.getProjectVariables()).map((i) => ({ label: i, value: i }));
    },
  },
  methods: {
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.aiPayload.max_length = this.aiPayload.max_length.toString();
      this.$emit('update', this.payload);
    }, 300),
    onProviderChange() {
      this.aiPayload.model = '';
    },
    onAddPersonaClick() {
      this.$showModal(CreatePersonaModal, { projectId: this.projectId });
    },
  },
  watch: {
    item: {
      handler() {
        if (this.item) {
          this.aiPayload = JSON.parse(JSON.stringify(this.item.payload));
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
